export const slotsSelector = (state) => state.dateAndTimeStep.slots;
export const slotsLoadingSelector = (state) => state.dateAndTimeStep.slotsLoading;
export const selectedSlotSelector = (state) => state.dateAndTimeStep.selectedSlot;
export const slotPopUpSelector = (state) => state.dateAndTimeStep.slotPopUp;

export const selectedSlotObjectSelector = (state) =>
  state.dateAndTimeStep.slots.find((slot) => slot.id === state.dateAndTimeStep.selectedSlot);
export const selectedDateSelector = (state) => state.dateAndTimeStep.selectedDate;
export const isNextFreeSlotLoadingSelector = (state) => state.dateAndTimeStep.isNextFreeSlotLoading;
